import { Mountains } from '@phosphor-icons/react';

export default Mountains;
